<template>
  <tr>
    <td>
      <v-select
        id="field-select"
        :options="fields"
        label="name"
        @update:modelValue="selectedField"
        v-model="field"
      />
    </td>
    <td>
      <v-select
        id="operator-select"
        :options="i18nOperators"
        @update:modelValue="selectedOperator"
        label="label"
        v-model="operator"
      />
    </td>
    <td>
      <v-select
        id="value-select"
        :options="values"
        @update:modelValue="selectedValue"
        :taggable="true"
        :title="value"
        :filtrable="false"
        :disabled="valueDisabled"
        v-model="value"
      />
    </td>
    <td class="actions-cell">
      <div class="btn-group actions-buttons">
        <button
          type="button"
          class="btn btn-danger"
          @click="$emit('remove-condition', index)"
        >
          <span class="glyphicon glyphicon-trash"></span>
        </button>
        <button
          class="btn btn-default"
          v-if="last"
          @click="$emit('add-condition')"
        >
          <span class="glyphicon glyphicon-plus"></span>
        </button>
      </div>
    </td>
  </tr>
</template>

<script>
import {mapState, mapActions} from 'vuex';

export default {
  name: 'DisplayConditionRow',
  props: {
    last: Boolean,
    condition: Object,
    index: Number
  },
  computed: {
    ...mapState({
      fields: state => state.displayModule.fields,
      valuesMap: state => state.displayModule.values,
      templateData: state => state.templateData
    }),
    i18nOperators: function () {
      return this.operators.map(o => {
        o.label = this.$t(`filters.${o.value}`);
        return o;
      });
    }
  },
  created: function () {
    if (
      Object.keys(this.condition).length > 1 &&
      this.condition.constructor === Object
    ) {
      this.field = this.getFieldByName(this.condition.field);
      this.operator = this.getOperatorByValue(this.condition.operator);

      this.selectedField(this.field);
      this.value =
        this.condition.values.length > 0 ? this.condition.values[0] : undefined;
      this.selectedValue(this.value);
    }
  },
  methods: {
    ...mapActions('displayModule', ['retrieveSourceFieldValues']),
    async selectedField(value) {
      const payload = {
        sourceId: this.templateData.mergeTagsSource.id,
        field: value.name
      };
      if (!this.valuesMap.has(value.name)) {
        await this.retrieveSourceFieldValues(payload);
      }
      this.field = value.name;
      this.condition.field = value.name;
      this.updateAvailableValues();
    },
    selectedOperator(value) {
      this.condition.operator = value.value;
      if (value.arity === 'none') {
        this.valueDisabled = true;
      } else {
        this.valueDisabled = false;
      }
    },
    selectedValue(value) {
      this.condition.value = value;
    },
    getOperatorByValue(value) {
      return this.operators.find(element => element.value === value);
    },
    getFieldByName(name) {
      return this.fields.find(element => element.name === name);
    },
    updateAvailableValues() {
      if (this.valuesMap.has(this.field)) {
        this.values = this.valuesMap.get(this.field) || [];
      } else {
        this.values = [];
      }
    }
  },
  data: function () {
    return {
      operators: [
        {
          value: 'EQ',
          arity: 'one'
        },
        {
          value: 'NOT_EQ',
          arity: 'one'
        },
        {
          value: 'CONTAINS',
          arity: 'one'
        },
        {
          value: 'NOT_CONTAINS',
          arity: 'one'
        },
        {
          value: 'GT',
          arity: 'one'
        },
        {
          value: 'LT',
          arity: 'one'
        },
        {
          value: 'EMPTY',
          arity: 'none'
        },
        {
          value: 'NOT_EMPTY',
          arity: 'none'
        },
        {
          value: 'NULL',
          arity: 'none'
        },
        {
          value: 'NOT_NULL',
          arity: 'none'
        }
      ],
      field: '',
      operator: '',
      values: [],
      value: '',
      valueDisabled: false
    };
  }
};
</script>

<style scoped>
.actions-cell {
  text-align: right;
}

.actions-buttons {
  margin-left: 10px;
  display: flex;
  align-items: center;
  gap: 3px;
}

.actions-buttons .btn {
  margin: 0;
}

#field-select,
#operator-select,
#value-select {
  width: 100%;
}

.v-select {
  width: 100%;
  min-width: 130px;
  box-sizing: border-box;
}

::v-deep(.vs__actions) {
  display: flex;
  align-items: center;
  gap: 5px;
  flex-shrink: 0;
}

::v-deep(.vs__search) {
  width: 0 !important;
  padding: 0 !important;
  border: none !important;
  margin: 0 !important;
  height: 0 !important;
}
</style>
